import { BaseAuthService } from "../base/baseApiAuth";


export class RolesService extends BaseAuthService {
    async getUsers() {
        try {
            const { data } = await this.axiosClient.get(`users`);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in getUsers with stack: ${error}`);
        }
    }

    // async getUser(token: any) {
    //     try {
    //         const { data } = await this.axiosClient.get(`users/token/${token}`);
    //         return data;
    //     } catch (error) {
    //         // throw new Error(`An unhandled exception in getUsers with stack: ${error}`);
    //     }
    // }

    async searchUsers(filter: string) {
        try {
            const { data } = await this.axiosClient.get(`users/search/code-word?code_word=${filter}`);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in getUsers with stack: ${error}`);
        }
    }

    async getRoles() {
        try {
            const { data } = await this.axiosClient.get(`roles`);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in getUsers with stack: ${error}`);
        }
    }

    async getPermissions() {
        try {
            const { data } = await this.axiosClient.get(`permissions`);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in getUsers with stack: ${error}`);
        }
    }

    async getUserPermissions(id: any) {
        try {
            const { data } = await this.axiosClient.get(`users/get/permissions?user_id=${id}`);
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in getUsers with stack: ${error}`);
        }
    }

    async updateRole(role: number, userId: number) {
        try {
            const { data } = await this.axiosClient.put(`users/update/role/${userId}`, { role });
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in getUsers with stack: ${error}`);
        }
    }

    async updateStatus(status: any, userId: number) {
        try {
            const { data } = await this.axiosClient.put(`users/update/status/${userId}`, { status });
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in getUsers with stack: ${error}`);
        }
    }

    async assignPermissions(permissions: any, userId: number) {
        try {
            const { data } = await this.axiosClient.post(`users/assign?user_id=${userId}`, { permissions });
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in getUsers with stack: ${error}`);
        }
    }

    async removePermissions(permissions: any, userId: number) {
        try {
            const { data } = await this.axiosClient.post(`users/remove?user_id=${userId}`, { permissions });
            return data;
        } catch (error) {
            throw new Error(`An unhandled exception in getUsers with stack: ${error}`);
        }
    }
}

export default new RolesService();